import './SearchableTimelineList.scss';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { PeriscopeV3PaginatedList } from '../PeriscopeV3PaginatedList';
import { TimelineEntry } from '@sonar-software/sonar-core';
import { TimelineRecord } from './TimelineRecord';
import { timelineSortOptions } from './TimelineSortOptions';
import { trigger } from '@lib/events';
import { Button, Row } from 'antd';
import { keyPaginationDefaultQueryParams, keyPaginationFallbackQueryParams } from '@ui/KeyPagination';
import { KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';
import { QueryParams, useQueryResource } from '@hooks';
import React, { useCallback } from 'react';
import { TimelineSearch, TimelineSearchQueryParams } from './TimelineSearch';

type Resource = PaginatedResource<TimelineEntry>;

export type SearchableTimelineListQueryParams = QueryParams & KeyPaginationQueryParams & TimelineSearchQueryParams;

export interface SearchableTimelineListProps {
	sonarObjectId: number;
}

export const SearchableTimelineList: React.FC<SearchableTimelineListProps> = ({ sonarObjectId }) => {
	const { loading, resource, queryParams, updateParams } = useQueryResource<
		Resource,
		SearchableTimelineListQueryParams
	>({
		defaultParams: {
			...keyPaginationDefaultQueryParams,
			sortBy: timelineSortOptions[ 0 ].key,
			sortDirection: timelineSortOptions[ 0 ].direction
		},
		fallbackParams: keyPaginationFallbackQueryParams,
		uri: `v3/core/sonar-objects/${sonarObjectId}/timelines`
	});

	const handleExpandAll = useCallback(() => {
		trigger(`periscope-timeline-${sonarObjectId}:expandAll`);
	}, [ sonarObjectId ]);

	const handleCollapseAll = useCallback(() => {
		trigger(`periscope-timeline-${sonarObjectId}:collapseAll`);
	}, [ sonarObjectId ]);

	return (
		<>
			<TimelineSearch
				onChange={ updateParams }
				queryParams={ queryParams }
				sonarObjectId={ sonarObjectId } />
			<Row className='expand-collapse-row'>
				<Button
					className='expand-all-button'
					onClick={ handleExpandAll }
					size='small'
					type='link'>
					{ COPY_GENERIC.EXPAND_ALL }
				</Button>
				<Button
					className='collapse-all-button'
					onClick={ handleCollapseAll }
					size='small'
					type='link'>
					{ COPY_GENERIC.COLLAPSE_ALL }
				</Button>
			</Row>
			<PeriscopeV3PaginatedList
				loading={ loading }
				onChange={ updateParams }
				queryParams={ queryParams }
				renderListItem={ (item) =>
					<TimelineRecord
						key={ item.change.id }
						parentSonarObjectId={ sonarObjectId }
						record={ item } /> }
				resource={ resource } />
		</>
	);
};
